import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, ref } from "vue";
import { IImageConfig } from "@/types/apartmentPlan";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiagramImageComponent',
  props: {
    diagramConfig: {},
    diagramComponent: {},
    rotationOffset: {}
  },
  setup(__props: any) {

const props = __props;

const diagramImage = ref<HTMLImageElement | null>(null);

function loadDiagramImageAsset() {
  const img = new Image();
  img.onload = () => {
    diagramImage.value = img;
  };
  img.src = props.diagramComponent;
}

onMounted(() => {
  loadDiagramImageAsset();
});

const diagramComponentConfig = computed<IImageConfig | null>(() => {
  if (props.diagramConfig === null) {
    return null;
  }

  return {
    image: diagramImage.value,
    x: props.diagramConfig.x,
    y: props.diagramConfig.y,
    width: props.diagramConfig.width,
    height: props.diagramConfig.height,
    offsetY: props.diagramConfig.offsetY,
    offsetX: props.diagramConfig.offsetX,
    rotation: props.diagramConfig.rotation + 30 * props.rotationOffset,
    scaleX: props.diagramConfig.scaleX,
    scaleY: props.diagramConfig.scaleY,
  };
});

return (_ctx: any,_cache: any) => {
  const _component_v_image = _resolveComponent("v-image")!

  return (_openBlock(), _createBlock(_component_v_image, { config: diagramComponentConfig.value }, null, 8, ["config"]))
}
}

})